import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const armis = defineConnector({
  identifier: "armis",
  name: "Armis",
  tagLine: "Asset visibility and security",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://[^/]*\\.armis\\.com/api/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `${app.config.baseUrl}/api/v1/access_token/`,
        method: "POST",
        headers: [{ name: "accept", value: "application/json" }],
        formBody: {
          secret_key: app.secret.apiKey,
        },
      },
      extract: { from: "jsonPath", paths: ["data.access_token"] },
      // Armis v1 treats the whole Authorization value as the token and rejects a Bearer prefix.
      apply: { kind: "header" },
    }),
  steps: [
    {
      title: "Get API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your Armis console and navigate to Settings > API Management to generate a secret API key.",
        },
      ],
    },
    {
      title: "Enter your Armis instance URL",
      items: [
        {
          kind: "baseUrl",
          label: "Instance URL",
          placeholder: "https://yourdomain.armis.com",
          required: true,
          target: { kind: "configuration", field: "baseUrl" },
          helperText:
            "The same URL you use to log in to Armis (e.g., https://yourdomain.armis.com).",
        },
      ],
    },
    {
      title: "Copy and paste the secret key into the field below",
      items: [
        {
          kind: "input",
          label: "Armis secret key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url: `${baseUrl}/api/v1/devices/?search=teststring&length=1`,
      method: "GET",
      headers: { accept: "application/json" },
      expectedBodyContains: '"success":true',
    }),
  },
  publicEnvVars: ({ baseUrl }) => ({
    ARMIS_URL: baseUrl || "",
  }),
});
